// extracted by mini-css-extract-plugin
export var text = "_11-0";